import React, { useEffect, useState } from "react";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const EmployeeDetailsReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Details Report"));
  }, []);

  const [employeeDetailsReportData, setEmployeeDetailsReportData] = useState(
    []
  );
  const [empOptions, setEmpOption] = useState([]);
  const [empTypeOption, setEmpTypeOption] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [shiftOptions, setShiftOptions] = useState([]);
  const [subDeptOptions, setSubDeptOptions] = useState([]);

  useEffect(() => {
    fetchGetData();
  }, []);

  const fetchGetData = async () => {
    SetApiStatus(undefined)
    try {
      let response;
      response = await GetServiceCaller(
        `${API_URL}org-report/1?P_ID=&P_EmployeeID=&P_ShiftID=&P_SubDepartmentID=`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const cleanedData = response?.data;

        const empOptions =
          cleanedData?.employeeName?.map((ele) => ({
            value: ele?.value || "",
            label: ele?.text || "",
          })) || [];
        setEmpOption(empOptions);

        const empTypeOptions =
          cleanedData?.employeeType &&
            typeof cleanedData.employeeType === "object"
            ? Object.entries(cleanedData.employeeType).map(([key, value]) => ({
              value: key || "",
              label: value || "",
            }))
            : [];

        setEmpTypeOption(empTypeOptions);
        const shiftOptions =
          cleanedData?.shift?.map((ele) => ({
            value: ele?.value || "",
            label: ele?.text || "",
          })) || [];
        setShiftOptions(shiftOptions);

        const subDeptOptions =
          cleanedData?.subDepartment?.map((ele) => ({
            value: ele?.value || "",
            label: ele?.text || "",
          })) || [];

        setSubDeptOptions(subDeptOptions);

        setEmployeeDetailsReportData(response?.data?.data);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };
  const columns = {
    EmployeeCode: { text: "EMP ID", align: "start", visible: true },
    ProfileImage: { text: "", align: "left", type: "Image", visible: true },
    ContactName: {
      text: "Employee",
      align: "start",
      visible: true,
      type: "Link",
    },
    Gender: { text: "Gender", align: "start", visible: false },
    DateOfBirth: { text: "Date Of Birth", align: "center", visible: true },
    JoiningDate: { text: "Joining Date", align: "center", visible: true },
    Department: { text: "Department", align: "start", visible: true },
    SubDepartment: { text: "Sub Department", align: "start", visible: false },
    Designation: {
      text: "Designation",
      align: "start",
      whiteSpace: "nowrap",
      visible: true,
    },
    SubBand: { text: "Band", align: "center", visible: false },
    ReportingManager: {
      text: "Reporting Manager",
      align: "start",
      visible: true,
    },
    PrevExp: {
      text: "Prev Exp.",
      align: "start",
      visible: false,
    },
    NiceExp: {
      text: "Nice Exp.",
      align: "start",
      visible: false,
    },
    TotalExperience: {
      text: "Total Exp.",
      align: "start",
      visible: false,
    },
    MobileNo1: { text: "Contact No.", align: "center", visible: true },
    OfficialEmail: { text: "Official Email", align: "start", visible: true },
    PersonalEmail: { text: "Personal Email", align: "start", visible: false },
    BaseLocation: { text: "Base Location", align: "start", visible: false },
    Location: { text: "Location", align: "start", visible: false },
    PANNo: { text: "PAN #", align: "center", visible: false },
    AadhaarCardNo: { text: "Aadhaar Card #", align: "center", visible: false },
    BankName: { text: "Bank Name", align: "start", visible: false },
    BankBranchName: {
      text: "Bank Branch Name",
      align: "start",
      visible: false,
    },
    BankAccountNo: { text: "Bank Account No.", align: "end", visible: false },
    BankIFSCCode: { text: "Bank IFSC Code", align: "end", visible: false },
    FatherName: { text: "Father Name", align: "start", visible: false },
    FatherDOB: { text: "Father DOB", align: "center", visible: false },
    MotherName: { text: "Mother Name", align: "start", visible: false },
    MotherDOB: { text: "Mother DOB", align: "center", visible: false },
    EmergencyPhoneNumber: {
      text: "Emergency Phone No.",
      align: "center",
      visible: false,
    },
    LocalContact: { text: "Local Contact", align: "center", visible: false },
    RelivingDate: { text: "Reliving Date", align: "center", visible: false },
    ResignationDate: {
      text: "Resignation Date",
      align: "center",
      visible: false,
    },
    PFNo: { text: "PF No.", align: "center", visible: false },
    UANNo: { text: "UAN No.", align: "center", visible: false },
    PassportNo: { text: "Passport No.", align: "center", visible: false },
    DrivingLicenceNo: {
      text: "Driving Licence No.",
      align: "center",
      visible: false,
    },
    AppointmentDate: {
      text: "Appointment Date",
      align: "center",
      visible: false,
    },
    BloodGroup: { text: "Blood Group", align: "center", visible: false },
    Shift: { text: "Shift", align: "start", visible: false },
  };

  const formDatas = [
    {
      name: "Employee Type",
      type: "Select",
      options: [...empTypeOption],
    },
    {
      name: "Employee Name",
      type: "Select",
      options: [...empOptions],
    },
    {
      name: "Shift",
      type: "Select",
      options: [...shiftOptions],
    },
    {
      name: "Sub Department",
      type: "Select",
      options: [...subDeptOptions],
    }
  ];

  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const employeeTypeObj = filterFormData.find(
        (o) => o.label === "Employee Type"
      );
      const employeeNameObj = filterFormData.find(
        (o) => o.label === "Employee Name"
      );
      const shiftNameObj = filterFormData.find(
        (o) => o.label === "Shift"
      );
      const subDeptNameObj = filterFormData.find(
        (o) => o.label === "Sub Department"
      );

      const pID = employeeTypeObj?.value || 0;
      const empType = employeeNameObj?.value || 0;
      const shift = shiftNameObj?.value || 0;
      const subDepartment = subDeptNameObj?.value || 0;
      
      const response = await GetServiceCaller(
        `${API_URL}org-report/1?P_ID=${pID}&P_EmployeeID=${empType}&P_ShiftID=${shift}&P_SubDepartmentID=${subDepartment}`
      );

      SetApiStatus(response?.status);

      if (response?.status === 200) {
        setEmployeeDetailsReportData(response?.data?.data);
      } else {
        console.error("No Data Found");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const hanldeLinkColumn = (column, item) => {
    navigate(`/employee-profile/${item.ID}`);
  };


  const handleReset = () => {
    setFilterData([])
    fetchGetData()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={employeeDetailsReportData}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              isActionRequired={false}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              showIcon3={true}
              showIcon4={true}
              showIcon5={false}
              isFilterRequired={true}
              // isSorting={true}
              handleReset={handleReset}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              filterFormData={filterFormData}
              isAddNewBtnRequired={false}
              hanldeImageClick={handleImageClick}
              hanldeLinkColumn={hanldeLinkColumn}
              // handleAddNew={handleAddCustomer}
              handleGetData={handleGetData}
              // handleIcon1={handleEdit}
              // handleIcon2={handleEmployeeSelection}
              // handleIcon3={handleInterViewStatusReport}
              // handleIcon4={handleSendJD}
              // handleIconClick={handleJD}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon2: <i class="bi bi-people-fill icons"></i>,
                Icon2Text: " Employee Selection",
                Icon3Text: "Interview Status",
                Icon3: <i class="bi bi-box-arrow-up-right icons"></i>,
                Icon4: <i class="bi bi-envelope icons"></i>,
                Icon4Text: "Send JD",
                Icon5Text: "JD",
                Icon5: <i class="bi bi-eye-fill icons"></i>,
              }}
            />
          </div>
        </div>
      </div>

      <Modal show={isModalOpen} onHide={closeModal} centered size="md">
        <img
          src={selectedImage}
          alt="Enlarged Profile"
          style={{ maxWidth: "100%", maxHeight: "70vh" }}
        />
      </Modal>
    </>
  );
};

export default EmployeeDetailsReport;
